import { useMutation, useQuery } from '@tanstack/react-query';

import { getStrategyInfo, updateStrategy } from '../../../../../../api';
import { AggregateStrategy } from '../../../../../../types/aggregateStrategy';

type StrategyInfoResponse = {
  result: AggregateStrategy;
};

export const useStrategyInfo = (strategyId: string) =>
  useQuery({
    queryKey: ['getStrategyInfo', strategyId],
    queryFn: () => getStrategyInfo(strategyId),
    enabled: Boolean(strategyId),
    select: (response: StrategyInfoResponse) => response.result,
  });

export const useUpdateStrategy = () =>
  useMutation({
    mutationKey: ['updateStrategy'],
    mutationFn: (data: Partial<AggregateStrategy>) => updateStrategy(data),
  });
